import { DisplayPriceGettingParams } from '../../../../../../baseComponents/Displays/DisplayPrice'

interface CustomInputTotalsTablePriceTPVProps {
    currency: string
    inputName: string
    value: number
    className: string
    classNameValue: string
}

export const CustomInputTotalsTablePriceTPV: React.FC<CustomInputTotalsTablePriceTPVProps> = ({ inputName, value, className, classNameValue, currency}) => {
    return (
        <div className='total_price_tpv flex flex-row items-center justify-between w-full gap-10 flex-wrap'>
            <div className={ (className || '')}>{inputName}</div>
            <span className={'flex ' + (classNameValue || '')}>
                <DisplayPriceGettingParams CurrencyId={currency} value={value} with_vat={false} />
            </span>
        </div>
    )
}
export default CustomInputTotalsTablePriceTPV

